module.exports = __webpack_public_path__ + "img/contact_2.d8dbac1.png";